import React, {useState, useEffect} from 'react'
// import './BasicImageList.css'
import '../CowImageList/BasicImageList.css'
import Title from '../Title/Title';
// import { useNavigate } from 'react-router-dom';
import ImageList from '@mui/material/ImageList';
//import ImageListItem from '@mui/material/ImageListItem';
// import ListSubheader from '@mui/material/ListSubheader';
// import {Stack, TextField, Button } from '@mui/material';
import { BasicImageItems } from '../CowImageList/BasicImageItems';
// import { colors } from '@mui/material';
import ProgramCommentsList from './programcommentslist';
import TextCaptureModal from '../Dialog/textcapturemodal';
import ProgressIndicator from '../Indicator/ProgressIndicator';
import SelectCow from './selectcow';
import { useToast } from '../Toast/ToastContext';

// import { Flare } from '@mui/icons-material';

const RawImageList = ({title, imglist, data}) => {
    // let navigate = useNavigate();
    const [itemscount, setItemscount] = useState(imglist.length);
    const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
    const [desc, setDescription] = useState(data.Description);
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const [summ, setSummary] = useState(data.Summary);
    const [isLoading, setLoadingValue]=useState(false);
    const [showCowForm, setShowForm]=useState(false);


    const showToast = useToast();

    const columnCount =  1; //imglist.length <6 ? 1 : 2 ;
    useEffect(()=>{
      if(itemscount !== imglist.length){
        setItemscount(imglist.length);
      }
    }, [imglist, itemscount]);    

    const updatedescription=() => {
    setIsDescriptionOpen(true);
    }

    const updateSummary=()=>{
    setIsSummaryOpen(true);
    }

        const AddCow=()=>{
          // alert('hello');
          // setShowCowlist(true);
          setShowForm(true);
        }
    

    const handleDescriptionSubmit = async (text)=>{
      // alert('hello description ' + text);
      setLoadingValue(true);
      try{
            const API_URL = `https://sasyavatagro.com/repos/api/dairyfarm/UpdateProgramDescription?ProgramId=${data.ProgramId}&Description=${text}`; 
            const response = await fetch(API_URL);
            if (!response.status) throw Error("Failed to fetch data");
            const result = await response.json();    
            setDescription(text);
            showToast("Description saved successfully!", "success");
      } catch(e){
        console.log(e)
        showToast("Error uploading description!", "error");
      } finally {
        setLoadingValue(false);      
      }
    }

    const handleSummarySubmit = async (text)=>{
      // alert('hello summary');
      setLoadingValue(true);
      try{
            const API_URL = `https://sasyavatagro.com/repos/api/dairyfarm/UpdateProgramSummary?ProgramId=${data.ProgramId}&Summary=${text}`; 
            const response = await fetch(API_URL);
            if (!response.status) throw Error("Failed to fetch data");
            const result = await response.json();    
            setSummary(text);
            showToast("Summary saved successfully!", "success");
      } catch(e){
        console.log(e)
        showToast("Error uploading summary!", "error");
      } finally {
        setLoadingValue(false);      
      }      
    }

    const handleCowsSubmit =async (cowlst)=>{
     console.log(cowlst);
//      console.log(data.ParticipatingCows);
      let newcowlist = cowlst;
      if(data.ParticipatingCows.length>0){
        newcowlist = data.ParticipatingCows + "," + cowlst;        
      }
      console.log(newcowlist);
      setLoadingValue(true);
      try{
            const API_URL = `https://sasyavatagro.com/repos/api/dairyfarm/UpdateProgramCowlist?ProgramId=${data.ProgramId}&ParticipatingCows=${cowlst}`; 
            const response = await fetch(API_URL);
            if (!response.status) throw Error("Failed to fetch data");
            const result = await response.json();    
            // setDescription(text);
            showToast("Cows updated successfully!", "success");
      } catch(e){
        console.log(e)
        showToast("There was an error uploading cows", "error");
      } finally {
        setLoadingValue(false);      
      }
    }

    return (
    <div className='BasicImageListClass'>
    {isLoading && <ProgressIndicator /> }
    <Title title={data.Title} />
    <div style={{textAlign:'left', paddingTop:'10px', paddingLeft:'20px'}}>
      <div style={{paddingTop:'10px', paddingBottom:'10px'}}>
      <b>Program Date</b> {data.CreateDate.substring(0,10)}
    </div>
    <SelectCow openForm={showCowForm} ShowForm={() => setShowForm(false)} onSubmit={handleCowsSubmit} ExistingList={data.ParticipatingCows} />

    <TextCaptureModal
    open={isDescriptionOpen}
        handleClose={() => setIsDescriptionOpen(false)}
        handleSubmit={handleDescriptionSubmit}
        title={"Enter Description"}
        deftext={desc}
    />
    <TextCaptureModal
    open={isSummaryOpen}
        handleClose={() => setIsSummaryOpen(false)}
        handleSubmit={handleSummarySubmit}
        title={"Enter Summary"}
        deftext={summ}
    />

      <div style={{display:'flex', flexDirection:'row', backgroundColor:'lightgrey', paddingRight:'10px', 
        paddingLeft:'10px', marginRight:'10px', lineHeight:'1.5', justifyContent:'space-between'}}> <b>Description</b>
       <span style={{width:'40px', backgroundColor:'blueviolet',color:'white', paddingLeft:'5px', paddingRight:'5px', paddingTop:'2px', paddingBottom:'2px', 
        margin:'2px', borderRadius:'5px', textAlign:'center', fontSize:'12px'}} onClick={updatedescription}>Edit</span> 
      </div>
      <div style={{paddingTop:'10px', paddingBottom:'10px'}}>
        {desc}
      </div>
      <div style={{display:'flex', flexDirection:'row', backgroundColor:'lightgrey', paddingRight:'10px', 
        paddingLeft:'10px', marginRight:'10px', lineHeight:'1.5', justifyContent:'space-between'}}> <b>Summary</b>
       <span style={{width:'40px', backgroundColor:'blueviolet',color:'white', paddingLeft:'5px', paddingRight:'5px', paddingTop:'2px', paddingBottom:'2px', 
        margin:'2px', borderRadius:'5px', textAlign:'center', fontSize:'12px'}} onClick={updateSummary}>Edit</span> 
      </div>
      <div style={{paddingTop:'10px', paddingBottom:'10px'}}>
        {summ}
      </div>    
    </div>
<div style={{display:'flex', flexDirection:'row', backgroundColor:'lightgrey', paddingRight:'10px', 
        paddingLeft:'10px', marginLeft:'10px', marginRight:'10px', marginBottom:'-15px', lineHeight:'1.5', justifyContent:'flex-end'}}> 
       <span style={{width:'60px', backgroundColor:'blueviolet',color:'white', paddingLeft:'5px', paddingRight:'5px', paddingTop:'2px', paddingBottom:'2px', 
        margin:'2px', borderRadius:'5px', textAlign:'center', fontSize:'12px'}} onClick={AddCow}>Add Cow</span> 
      </div>
    <div className='BasicImageContent' >
    { itemscount <= 0 ? 
    <div>No item in the list</div>
    : <> <ImageList  cols={ columnCount } 
        sx={{
          // paddingRight:'20px',
          width:'100%',          
        }}
    >      
    {/* <img src='https://sasyavatagro.com/img/farmimg/cow_img.png'></img> */}
      <BasicImageItems imagelist={imglist} />
    </ImageList>
                <div style={{paddingTop:'10px'}}>
            <ProgramCommentsList id={data.ProgramId} />
            </div>
            </>
    }

    </div>
    </div>
  )
}

export default RawImageList